import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import Button from '../../shared/components/Form/Button';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import Modal from '../../shared/components/UIElements/Modal';
import Map from '../../shared/components/UIElements/Map';
import Avatar from '../../shared/components/UIElements/Avatar';

import './ClassInfo.css';

const ClassInfo = props => {
  const [showMap, setShowMap] = useState(false);
  const [error, setError] = useState();
  
  const openMapHandler = () => setShowMap(true);

  const closeMapHandler = () => setShowMap(false);

  const handleMapError = (err) =>{
     setShowMap(false);
     setError(err);
  }
   
  const clearError = () => {
    setError(null);
  };
    
     return (
      <React.Fragment>
         <ErrorModal error={error} onClear={clearError} />
        <Modal
        show={showMap}
        onCancel={closeMapHandler}
        header={props.title}
        className="mapModal"
        contentClass="place-item__modal-content"
        footerClass="place-item__modal-actions"
        footer={<Button onClick={closeMapHandler}>CLOSE</Button>}
      >
        <div className="map-container">
          <Map cs={props.id} dataset={props.datasetid} error={error} onError={handleMapError} ontology={props.ontology}/>
        </div>
      </Modal>
         <div className="classInfo">
             
          <h1>{props.title}</h1>
          <div className="class-description__image">
            <Avatar image={props.image} alt={props.title} />
          </div>
          <div className="class-description__info">
            <p><a href={props.uri} target="new">{props.uri}</a></p>
            <p><i>{props.description}</i> </p>
            <p><b>Dataset:</b> <Link to={`/datasets/${props.datasetid}`}>{props.dataset}</Link>
            </p>
            <p><b>Spatial Ontology: </b> {props.ontology} (<a href={props.ontology_uri} target="new">{props.ontology_uri}</a>)
            </p>
            <p><b>Entities:</b> {props.numOfEntities} </p>
            <p><b>Recommendations:</b> {props.numOfRecommendations} </p>
            </div>
           <div className="class_dbuttons">
            <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/rdf/${props.datasetid}/${props.id}/${props.ontology}`} target="new">Download RDF</Button>
            <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/json/${props.datasetid}/${props.id}/${props.ontology}`} target="new">Download JSON</Button>
            <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/geojson/${props.datasetid}/${props.id}/${props.ontology}`} target="new">Download GeoJSON</Button>
            <Button onClick={openMapHandler}>View On Map</Button>
           
            </div>         
         </div>
         </React.Fragment>
     );
};

export default ClassInfo;
